import { inject, Injectable } from '@angular/core'
import { Carrier, CompanyCarrier } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class CarrierService {
  core = inject(CoreService)

  // todo parameters and schema
  async getCarriers(
    parameters: any = {},
    schema: any = { id: null, name: null }
  ): Promise<{
    items: Carrier[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    // todo this keep here or put it inside carrier.service.ts ?
    return await this.core.services.carrier.getList(parameters, schema)
  }

  async getCompanyCarriers(
    parameters: any = {},
    schema: any = {
      id: null,
      carrier: {
        id: null,
        name: null,
        color: null,
        position: null,
        tariffs: {
          id: null,
          name: null,
          const: null,
          position: null,
          cod: null,
        },
      },
    }
  ): Promise<{
    items: CompanyCarrier[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    // todo this keep here or put it inside carrier.service.ts ?
    return this.core.services.companyCarrier.getList(parameters, schema)
    // .then(result => (result?.items ?? []).map(companyCarrier => companyCarrier.carrier))
    // return await this.core.services.companyCarrier.getList(parameters, schema)
  }
}
